export { default } from './-private/class/modifier';
export { default as modifier } from './-private/function-based/modifier';